module.exports = __webpack_public_path__ + "static/img/image@2x (5).46694af3.png";